<script>
  import { accountSupportSection } from './account-support.js';
</script>

<section id={accountSupportSection.anchorId} class="support" aria-labelledby="support-title">
  <h2 id="support-title">{accountSupportSection.title}</h2>
  <p class="description">{accountSupportSection.description}</p>

  <div class="support-links">
    {#each accountSupportSection.links as link}
      {#if link.external}
        <a class="support-link" href={link.href} target="_blank" rel="noreferrer">{link.label}</a>
      {:else}
        <a class="support-link" href={link.href}>{link.label}</a>
      {/if}
    {/each}
  </div>
</section>

<style>
  .support {
    padding: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.025);
  }

  h2 {
    margin: 0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.3;
  }

  .description {
    margin: 8px 0 0;
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
    line-height: 20px;
  }

  .support-links {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .support-link {
    display: block;
    color: #e7b962;
    font-size: 14px;
    text-decoration: none;
    transition: color 160ms ease;
  }

  .support-link:hover,
  .support-link:focus-visible {
    color: #ffa800;
  }
</style>
